import React, { useState } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Button, CircularProgress, TextField, Snackbar, Alert } from '@mui/material';
import { httpService } from '../../services/httpService';

const SearchComponent = ({ handleSearch }) => {
  const [searchParams, setSearchParams] = useState({
    ats_name: "",
    postal_code: "",
    job_title: "",
    job_posting: "",
    number_of_items: "2",
    item_from: "0",
    company_id_list: "",
    company_id_list_exclude: "yes",
    exclude_employment_agencies: "",
    wz08_code: "",
    dkz: "",
    land: "",
    state: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleChange = (e) => {
    setSearchParams({
      ...searchParams,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const data = await httpService.searchJobs(searchParams);

      if (data.success === true) {
        handleSearch(data.data);
      } else {
        handleSearch(data.data);
      setErrorMessage(data.message);
      setSnackbarOpen(true);      }
    } catch (error) {
      console.error("API Error:", error);
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4, mt: 4 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
        {/* ats_name Dropdown */}
        <TextField 
          label="Nom ATS" 
          name="ats_name" 
          value={searchParams.ats_name} 
          onChange={handleChange} 
          variant="outlined" 
          sx={{ minWidth: 80 }} 
        />

        {/* Postal Code Input */}
        <TextField 
          label="Code Postal" 
          name="postal_code" 
          value={searchParams.postal_code} 
          onChange={handleChange} 
          variant="outlined" 
          sx={{ minWidth: 80 }} 
        />

        {/* Job Title Dropdown */}
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="job_title-label">Intitulé du Poste</InputLabel>
          <Select labelId="job_title-label" name="job_title" value={searchParams.job_title} onChange={handleChange}>
            <MenuItem value="">Aucun</MenuItem>
            <MenuItem value="Software Engineer">Ingénieur Logiciel</MenuItem>
            <MenuItem value="Data Scientist">Data Scientist</MenuItem>
            <MenuItem value="Product Manager">Chef de Produit</MenuItem>
          </Select>
        </FormControl>

        {/* Job Posting Dropdown */}
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="job_posting-label">Offre d'Emploi</InputLabel>
          <Select labelId="job_posting-label" name="job_posting" value={searchParams.job_posting} onChange={handleChange}>
            <MenuItem value="">Aucune</MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Expired">Expirée</MenuItem>
          </Select>
        </FormControl>

        {/* Company ID List Dropdown */}
        <TextField 
          label="Entreprise" 
          name="company_id_list" 
          value={searchParams.company_id_list} 
          onChange={handleChange} 
          variant="outlined" 
          sx={{ minWidth: 30 }} 
        />

        {/* Exclude Employment Agencies Dropdown */}
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="exclude_employment_agencies-label">Exclure les Agences d'Emploi</InputLabel>
          <Select
            labelId="exclude_employment_agencies-label"
            name="exclude_employment_agencies"
            value={searchParams.exclude_employment_agencies}
            onChange={handleChange}
          >
            <MenuItem value="">Aucune</MenuItem>
            <MenuItem value="YES">Oui</MenuItem>
            <MenuItem value="NO">Non</MenuItem>
          </Select>
        </FormControl>

        {/* WZ08 Code Dropdown */}
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="wz08_code-label">Code WZ08</InputLabel>
          <Select labelId="wz08_code-label" name="wz08_code" value={searchParams.wz08_code} onChange={handleChange}>
            <MenuItem value="">Aucun</MenuItem>
            <MenuItem value="N,J">N,J</MenuItem>
            <MenuItem value="A,B">A,B</MenuItem>
          </Select>
        </FormControl>

        {/* Search Button with Loader */}
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit} 
          sx={{ height: '56px', minWidth: '150px' }}
          disabled={loading} // Disable button while loading
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Rechercher"}
        </Button>
      </Box>

            {/* Snackbar for Error Message */}
            <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SearchComponent;
